export const validation = {
  socials: {
    min: 0,
    max: 6
  },
  copyrightText: { required: true },
  copyrightTextMaxChar: 100,
  footerLogo: 1
}
